import React, { useEffect, useState, useRef } from 'react';
import { Button, Typography, Box, Grid, Paper } from '@mui/material';

const wsUrl = 'wss://digisure-scrum-poker.tyme.workers.dev/digisure/websocket';

const votesOptions = [1, 2, 3, 5, 8, 13, 21, '?'];

function App() {
  const [votes, setVotes] = useState({});
  const [user, setUser] = useState(() => `User_${Math.floor(Math.random() * 1000)}`);
  const ws = useRef(null);

  useEffect(() => {
    ws.current = new WebSocket(wsUrl);

    ws.current.onmessage = (event) => {
      const message = JSON.parse(event.data);
      if (message.type === 'votes') {
        setVotes(message.votes);
      }
    };

    return () => ws.current.close();
  }, []);

  const castVote = (value) => {
    ws.current.send(JSON.stringify({ type: 'vote', user, value }));
  };

  const resetVotes = () => {
    ws.current.send(JSON.stringify({ type: 'reset' }));
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Scrum Poker
      </Typography>
      <Typography variant="h6">You are: {user}</Typography>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        {votesOptions.map((val) => (
          <Grid item xs={3} key={val}>
            <Button variant="contained" fullWidth onClick={() => castVote(val)}>
              {val}
            </Button>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 2, mt: 3 }}>
        <Typography variant="h6">Votes:</Typography>
        {Object.entries(votes).map(([user, vote]) => (
          <Typography key={user}>
            {user}: {vote}
          </Typography>
        ))}
      </Paper>

      <Button variant="outlined" color="secondary" sx={{ mt: 2 }} onClick={resetVotes}>
        Reset Votes
      </Button>
    </Box>
  );
}

export default App;
